export default __webpack_public_path__ + "static/media/Medico-seguro.c530cfd0.svg";